<ion-list lines="none" class="w-full flex flex-col gap-4 py-4">
  <!-- <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Lien de l'image"
      label-placement="floating"
      color="primary"
      [(ngModel)]="fullImage"
      (ionChange)="onInputChange($event)"
    ></ion-input>
  </ion-item> -->
  <app-file-upload [files]="pdfSrc" (inputChange)="onInputChange($event)" [fileUploadInputs]="fileUploadInputs" [blocIndex]="blocIndex"></app-file-upload>
</ion-list>